var mixin = {
  computed: {
  },
  methods: {
    onRemoveDealItem (dealItem) {
      let useDealObject = this.deal !== undefined && this.deal !== null
      let dealItemsFiltered = null
      if (dealItem.guid && dealItem.guid !== '' && dealItem.guid !== undefined) {
          if (useDealObject) {
            dealItemsFiltered = this.deal.items.filter(function (el) {         
              return el.guid !== dealItem.guid
            })
          } else {
            dealItemsFiltered = this.dealItems.filter(function (el) {         
              return el.guid !== dealItem.guid
            })
          }
      } else if (dealItem.id !== 0) {
        if (useDealObject) {
          dealItemsFiltered = this.deal.items.filter(function (el) {        
            return el.id !== dealItem.id
          })
        } else  {
          dealItemsFiltered = this.dealItems.filter(function (el) {        
            return el.id !== dealItem.id
          })
        }
      }
      
      if (dealItemsFiltered !== null) {
        if (useDealObject) {
          this.deal.items = dealItemsFiltered
          if (dealItem.dealItemType === 'Trade' && this.deal.items.filter((x) => x.dealItemType === 'Trade').length  === 0) this.hasTradeInventorySwitch = false
          if (dealItem.dealItemType === 'LeaseRenewal' && this.deal.items.filter((x) => x.dealItemType === 'LeaseRenewal').length  === 0) this.hasLeaseInventorySwitch = false
        } else {
          this.dealItems = dealItemsFiltered
          if (dealItem.dealItemType === 'Trade' && this.dealItems.filter((x) => x.dealItemType === 'Trade').length  === 0) this.hasTradeInventorySwitch = false
          if (dealItem.dealItemType === 'LeaseRenewal' && this.dealItems.filter((x) => x.dealItemType === 'LeaseRenewal').length  === 0) this.hasLeaseInventorySwitch = false
        }
      }
    },
    createGenericDealItem (configuration) {
      let result = {
        id: 0,
        vehicleType: null,
        salePrice: null,
        frontValue: null,
        holdValue: null,
        mvpValue: null,
        warValue: 0.00,
        finResValue: null,
        tradeNo: '',
        products: [],
        forInventory: (configuration && configuration.forInventory !== null && configuration.forInventory !== undefined) ? configuration.forInventory : null,
        lineComment: '',
        status: 'Active',
        dealItemType: configuration.type,
        lineAttachments: [],
        isPrimary: configuration.type === 'Sold',
        guid: crypto.randomUUID()
      }
      return result
    }
  }
}

export default mixin
